module.exports = __webpack_public_path__ + "lp/img/camera_icn_blocked.7e9961b5.svg";